import { defineMessages } from 'react-intl'

export const cancelSubscriptionMessages = defineMessages({
  ctaBtn: {
    id: 'cancelSubscription.ctaBtn',
    description:
      'CTA button text on modal asking to Cancel/Downgrade subscription',
    defaultMessage: 'Yes, Cancel',
  },
  cancelBtn: {
    id: 'cancelSubscription.cancelBtn',
    description:
      'Cancel button text on modal asking to cancel all subscriptions',
    defaultMessage: 'No, Keep',
  },
  titleNetwork: {
    id: 'cancelSubscription.titleNetwork',
    description:
      'A title of modal when user tries to cancel/downgrade network subscription',
    defaultMessage: 'Cancel Smart Network subscriptions?',
  },
  confirmTextNetwork: {
    id: 'cancelSubscription.confirmTextNetwork',
    description:
      'Modal confirm text for canceling/downgrade of active subscription',
    defaultMessage:
      'Are you sure you wish to cancel all of your Smart Network subscriptions? Your Smart Network subscriptions will end on {planEndDate}{br}When the subscription ends, your Savant Smart Network will have a limited feature set enabled.',
  },
})
